import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  {
    path:'l',
    component:LoginComponent
  },
  {
    path:'',
    component:HomeComponent,
    children:[
      {
        path:"",
        redirectTo:"/u",
        pathMatch: 'full'
      },
     {
       path:"u",
       loadChildren:()=>import('./modules/user-management/user-management.module').then(mod=>mod.UserManagementModule)
     },
     {
       path:"h",
       loadChildren:()=>import('./modules/helper-management/helper-management.module').then(mod=>mod.HelperManagementModule)
     }, 
     {
       path:"r",
       loadChildren:()=>import('./modules/report-management/report-management.module').then(mod=>mod.ReportManagementModule)
     } 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {  
      anchorScrolling: 'enabled'
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
